/*
 * Public API Surface of angular-material-formio
 */
export * from './lib/angular-material-formio.module';
